<div class="gameui-details">
  <mat-card appearance="outlined" class="info section" *ngIf="tournament">
    <div class="section__root">
      <h2 class="section__root__title">
        {{ tournament.name }}
      </h2>

      @if (startDate() && endDate()) {
        <div class="date-info">
          <div class="date">
            <mat-icon>alarm</mat-icon>
            <span>
              From:
              <span class="large-date">{{
                startDate() | fzDateFormat: 'local' | async
              }}</span>
            </span>
          </div>
          <div class="date">
            <mat-icon>alarm_on</mat-icon>
            <span>
              To:
              <span class="large-date">{{
                endDate() | fzDateFormat: 'local' | async
              }}</span>
            </span>
          </div>
        </div>
      }
      <p [innerHtml]="tournament.overview"></p>
    </div>
  </mat-card>
  <mat-card
    appearance="outlined"
    class="info section"
    cellspacing="0"
    cellpadding="6"
  >
    <div class="section__root">
      <h2 class="section__root__title">{{ game?.name }} Information</h2>
      <p
        class="no-margin"
        [innerHtml]="game?.metadata?.longDescription || game?.description"
      ></p>
    </div>
  </mat-card>
  <mat-card
    appearance="outlined"
    class="info section"
    cellspacing="0"
    cellpadding="6"
  >
    <div class="section__root">
      <h2 class="section__root__title">Game Information</h2>
      <div class="items">
        <div class="item">
          <img src="/shared/svg/notes.svg" />
          <div>
            <h4 class="label mat-label-medium">Description:</h4>
            <p class="text">{{ game?.description }}</p>
          </div>
        </div>
        <div class="item">
          <img src="/shared/svg/star.svg" />
          <div>
            <h4 class="label mat-label-medium">Experience:</h4>
            <p class="text">
              {{ game?.metadata?.experience }}
            </p>
          </div>
        </div>
        <div class="item">
          <img src="/shared/svg/language.svg" />
          <div>
            <h4 class="label mat-label-medium">Browser:</h4>
            <p class="text">
              {{ game?.metadata?.browser }}
            </p>
          </div>
        </div>
        <div class="item">
          <img src="/shared/svg/devices.svg" />
          <div>
            <h4 class="label mat-label-medium">System:</h4>
            <p class="text">
              {{ game?.metadata?.system }}
            </p>
          </div>
        </div>
        <div class="item">
          <img src="/shared/svg/format.svg" />
          <div>
            <h4 class="label mat-label-medium">Format:</h4>
            <p class="text">
              {{ game?.metadata?.format }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </mat-card>
</div>
